import React, { useState, useEffect, useRef } from 'react';
import { getTokenInfo } from '../../../UseToken';
import { api_crud_route } from './Config';
import { reqGET, reqPUT } from '../../../Utils';

const File = ({idFormation, idModule, idSession, isEdit}) => {

  const [, set_dados] = useState(null);
	const dados = useRef(null);

    const [questions, set_questions] = useState([])
    const [question, set_question] = useState('')

    const handle_add_question = () => {

        if(question !== '') {
            let aux = questions
            aux.push({id: (questions.length + 1), question: question})
            set_questions(aux)
            set_question('')
        }

    }

    const handle_edit_question = (e) => {
        const { value, dataset } = e.target
        const { order } = dataset

        let aux = questions
        aux[order].question = value
        set_questions(aux)

    }

    const handleSave = () => {

        dados.current.content[0].modules.forEach((el) => {

            if(el.id === idModule) {
                if(el['evaluations'] === undefined) {
                    el['evaluations'] = []
                } 

                el['evaluations'][idSession] = { type: 'file', questions: questions }

                reqPUT(api_crud_route, dados.current)
                    .then(() => { 
                        
                    })
                    .catch((error) => console.log('error', error))
            }

        })

    }

    useEffect(() => {

        //if(isEdit === true) {
            reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${idFormation}`)
                .then(res => {
                    
                    if(isEdit === true) {
                        res.data[0].content[0].modules.forEach(el => {
                            if(el.id === idModule && el['evaluations'][idSession] !== undefined && el['evaluations'][idSession] !== null && el['evaluations'][idSession] !== '') {
                                console.log('questions', el['evaluations'][idSession])
                                set_questions(el['evaluations'][idSession].questions)
                            }
                        })
                    }

                    set_dados(dados.current = res.data[0]);
                })
                .catch(error => console.log(error))
        //}

    }, [])

    return (
        <div className='row'>
            <div className='col-8'>
                <div className='row'>
                    {
                    questions.length > 0 ?
                        questions.map((el, k) => {
                            return (
                                <div key={k} className="col-6">
                                    <div className="card">
                                        <div className="card-header">
                                            Pergunta:
                                        </div>
                                        <div className="card-body">
                                            <span className="card-text">
                                                <input className='form-control' defaultValue={el.question} data-order={k} onBlur={handle_edit_question} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    :
                        null
                    }
                </div>
            </div>

            <div className='col-4'>
                Nova Pergunta
                <textarea type="text" className='form-control' value={question} onChange={(e) => set_question(e.target.value)} />
                <button type="button" className='btn btn-light float-right mt-2' onClick={handle_add_question} >Add</button>
            </div>

            <div className="col-12">
                <button type="button" className='btn btn-primary' onClick={handleSave}>Save</button>
            </div>
        </div>
    )

};

export default File;
